var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256,0C114.52,0,0,114.51,0,256S114.49,512,256,512a256.7,256.7,0,0,0,139.77-41.52A24.8,24.8,0,0,0,401.49,434L391,421.14a24.7,24.7,0,0,0-32.39-5.3A190.47,190.47,0,0,1,256,445.94c-104.73,0-189.93-85.2-189.93-189.93S151.26,66.08,256,66.08c103.37,0,189.93,59.48,189.93,165.16,0,40-21.77,82.31-60,86.39-17.91-.47-17.46-13.28-13.91-31l24.18-125a24.77,24.77,0,0,0-24.32-29.48H325.4a14,14,0,0,0-13.86,12.38v.1c-15.17-18.48-41.75-22.48-61.91-22.48-77,0-142.27,64.24-142.27,156.34,0,67.41,38,109.28,99.09,109.28,27.86,0,59.22-16.14,77.41-39.57,9.83,35.21,41.92,35.21,73,35.21C469.26,383.4,512,309.48,512,231.24,512,90.49,398.46,0,256,0ZM233.61,314.26c-23,0-37.23-16.13-37.23-42.09,0-46.44,31.77-75.07,60.52-75.07,23,0,36.75,15.73,36.75,42.08,0,46.52-35,75.08-60,75.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.793ca9d991c4fbb5862421b5b06263af.svg";
export { ForwardRef as ReactComponent };